export const CA = "6UGNg119LV6YjSCQ5K6Z6jsLLLetpMJ1vPdhiU8qpump";
export const PAIR_ADDRESS = "8LVi23yKtg2daMhyNYBoggnFLnPHrhLkveU2irqVSCgG";
export const BUY_URL =
  "https://dexscreener.com/solana/8lvi23yktg2damhynyboggnflnphrhlkveu2irqvscgg";
export const X_URL = "https://x.com/CryptoCurb?s=20";

export const TWEETS = [
  {
    id: "t1",
    embed: true,
    url: "https://x.com/bmac3503/status/2073896263662391511",
  },
  {
    id: "t2",
    embed: true,
    url: "https://x.com/smsonx/status/2073968592165470421",
  },
  {
    id: "t4",
    embed: true,
    url: "https://x.com/GhostOfSolami/status/2073944869601464518",
  },
  {
    id: "t5",
    embed: true,
    url: "https://x.com/CryptoCurb/status/2073799067029881053",
  },
  {
    id: "t6",
    embed: true,
    url: "https://x.com/CryptoCurb/status/2073998476971536873",
  },
  {
    id: "t7",
    embed: true,
    url: "https://x.com/CryptoCurb/status/2073844682031853905",
  },
];
